import React from 'react';
import * as Icon from 'react-bootstrap-icons';

import {
  GetSalesInvoiceDto,
  GetSalesInvoiceDtoPaymentStatusEnum,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { PaymentStatusObj } from '../../../common/pokCore/validation/enums';
import { useTranslation } from '../../../common/hooks/useTranslation';

export type GetSalesInvoiceWithPaymentDto = GetSalesInvoiceDto & {
  totalPaid?: number | null;
  lastPaymentDate?: Date | null;
};

const PAYMENT_STATUS_CLASSES: Record<string, string> = {
  [GetSalesInvoiceDtoPaymentStatusEnum.Paid]: 'payment-status-paid',
  [GetSalesInvoiceDtoPaymentStatusEnum.PartiallyPaid]:
    'payment-status-partially-paid',
  [GetSalesInvoiceDtoPaymentStatusEnum.Pending]: 'payment-status-pending',
  [GetSalesInvoiceDtoPaymentStatusEnum.Overdue]: 'payment-status-overdue',
  [GetSalesInvoiceDtoPaymentStatusEnum.OverduePartiallyPaid]:
    'payment-status-overdue-partially-paid',
};

interface PaymentStatusProps {
  invoice: GetSalesInvoiceWithPaymentDto;
}

export const PaymentStatus: React.FC<PaymentStatusProps> = ({ invoice }) => {
  const { t } = useTranslation('fvsLng');
  const status = invoice.paymentStatus;
  //   const totalPaid = invoice.totalPaid ?? 0;
  //   const lastPaymentDate = invoice.lastPaymentDate;
  //   const currency = invoice.company?.mainCurrency
  // ?.currencyCode as CurrencyIsoTypeEnum;

  if (!status) {
    return <></>;
  }

  //   const showAmount =
  //     (status === GetSalesInvoiceDtoPaymentStatusEnum.Paid ||
  //       status === GetSalesInvoiceDtoPaymentStatusEnum.PartiallyPaid ||
  //       status === GetSalesInvoiceDtoPaymentStatusEnum.Overdue) &&
  //     totalPaid > 0;

  return (
    <div style={{ whiteSpace: 'nowrap' }}>
      <Icon.CircleFill
        className={`me-1${status ? ` ${PAYMENT_STATUS_CLASSES[status]}` : ''}`}
        size={10}
      />
      {/* <small> */}
      {status ? t(PaymentStatusObj[status]) : ''}
      {/* {showAmount && (
          <>
            <br />
            <span>{numberFormatter(totalPaid, true, currency)}</span>
            {lastPaymentDate && (
              <span className="text-muted ms-1">
                ({momencik(lastPaymentDate)})
              </span>
            )}
          </>
        )} */}
      {/* </small> */}
    </div>
  );
};
